import styled from "styled-components";

export const BannerSecondaryWrapper = styled.div`
  background: #ffffff;

  .secondary-banner {
    padding-top: 130px;
    padding-bottom: 130px;
    @media (max-width: 575.98px) {
      padding-top: 50px;
      padding-bottom: 50px;
    }
    .banner-wrapper {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .store {
      @media (max-width: 575.98px) {
        margin-bottom: 25px;
      }
      .heading {
        font-family: Source Sans Pro;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 30px;
        color: #2d2d2d;
        margin-bottom: 0;
      }
      .text {
        font-family: Source Sans Pro;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 30px;
        color: #2d2d2d;
        margin-bottom: 10px;
      }
      .store-link {
        display: flex;
        .store-wrapper {
          height: 40px;
          &:first-child {
            margin-right: 10px;
          }
          img {
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
    .content {
      .heading {
        font-family: Source Sans Pro;
        font-style: normal;
        font-weight: bold;
        font-size: 54px;
        line-height: 64px;
        letter-spacing: 0.41px;
        color: #071e35;
        margin-bottom: 70px;
        @media (max-width: 575.98px) {
          font-size: 34px;
          line-height: 44px;
          margin-bottom: 40px;
        }
      }
      .content-list-wrapper {
        .content-list {
          display: flex;
          margin-bottom: 55px;
          &:last-child {
            margin-bottom: 0;
          }
          .icon-wrapper {
            margin-right: 15px;
            .icon {
              width: 80px;
              img {
                width: 100%;
                object-fit: contain;
              }
            }
          }
        }
      }
      .text-wrapper {
        .heading {
          font-family: Source Sans Pro;
          font-style: normal;
          font-weight: bold;
          font-size: 22px;
          line-height: 28px;
          letter-spacing: 0.35px;
          color: rgba(45, 45, 45, 0.85);
          margin-bottom: 5px;
        }
        .text {
          font-family: Source Sans Pro;
          font-style: normal;
          font-weight: normal;
          font-size: 17px;
          line-height: 22px;
          letter-spacing: -0.41px;
          color: #566068;
          margin-bottom: 0;
        }
      }
    }
  }
`;
